import { useEffect, useState } from "react";
import { fetchTemplates } from "../api/templatesApi";

/**
 * Returns placement_type of the primary (or first) saved bar template for theme editor deep links.
 */
export function usePrimaryTemplatePlacement(installChecked, clientId) {
  const [placementType, setPlacementType] = useState("product_page");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!installChecked || !clientId) {
      setPlacementType("product_page");
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await fetchTemplates();
        const list = res?.data?.templates ?? [];
        if (!Array.isArray(list) || !list.length) {
          if (!cancelled) setPlacementType("product_page");
          return;
        }
        const primary = list.find((t) => t.is_primary) || list[0];
        if (!cancelled) {
          setPlacementType(primary?.placement_type || "product_page");
        }
      } catch {
        if (!cancelled) setPlacementType("product_page");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [installChecked, clientId]);

  return { placementType, loading };
}
